import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import Tabs from '../../../../Template/layoutComponents/Tabs';

import HistoryTab from '../../../../Template/layoutComponents/HistoryTab';
import GeneralTab from '../../../../Template/layoutComponents/GeneralTab';

import {
  getAllAssetsByManufacturer,
  getManufacturers,
  updateManufacturer,
} from '../../../../Maintenance/helpers/apiCalls';
import { useMsal } from '@azure/msal-react';
import { notification } from 'antd';

import './style.css';
import AllAssetsTab from './components/allAssetsTab';
import useTemplateState from '../../../../Template/atoms/variables';
import useSettingsState from '../../../atoms/variables';
import useMaintenanceState from '../../../../Maintenance/atoms/variables';

const Details = () => {
  const { t } = useTranslation();

  const [notificationApi, contextHolder] = notification.useNotification();
  const { instance } = useMsal();
  const { categoryId } = useParams();

  const { setPendingApiCalls } = useTemplateState();
  const { setManufacturers } = useMaintenanceState();
  const { viewDetailsCategory, setViewDetailsCategory } = useSettingsState();

  useEffect(() => {
    if (!viewDetailsCategory) {
      triggerApiCalls();
    }
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getManufacturers']));

      const response = await getManufacturers(instance);
      setManufacturers(response);
      setViewDetailsCategory(response?.find((o) => o.id === categoryId || o._id === categoryId));
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getManufacturers'));
    }
  };

  return (
    <div id='categoryDetails'>
      {contextHolder}
      <Tabs
        tabs={[
          {
            label: t('general_tab'),
            content: (
              <GeneralTab detailsLink={'/settings/inventory'} updateItem={updateManufacturer} />
            ),
            disabled: false,
          },
          {
            label: t('all_assets'),
            content: <AllAssetsTab />,
          },
          {
            label: t('history_tab'),
            content: <HistoryTab id={categoryId} />,
            disabled: false,
          },
        ].filter((tab) => tab)}
      />
    </div>
  );
};

export default Details;
